import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { ConfirmDialog } from '../../../../common/views/modals/confirmDialog/ConfirmDialog';
import { songPageMessages } from '../../../../smartLinks/catalog/song/page/songPageMessages';
import { profileBioMessages as b } from './profileBioMessages';

interface BioLeaveDialogProps {
  isOpen: boolean;
  onLeave: () => void;
  onStay: () => void;
}

/** "Leave without saving the bio?" (design c1 note: a leave with unsaved text opens the leave dialog). */
const BioLeaveDialogComponent: React.FC<BioLeaveDialogProps> = ({ isOpen, onLeave, onStay }) => {
  const intl = useIntl();
  return (
    <ConfirmDialog
      isOpen={isOpen}
      tone="danger"
      title={intl.formatMessage(b.leaveTitle)}
      description={intl.formatMessage(b.leaveBody)}
      confirmLabel={intl.formatMessage(songPageMessages.leave)}
      cancelLabel={intl.formatMessage(songPageMessages.keepEditing)}
      onConfirm={onLeave}
      onCancel={onStay}
      testId="bio-leave-dialog"
    />
  );
};

export const BioLeaveDialog = TypedMemo(BioLeaveDialogComponent);
